import type { GetServerSideProps } from 'next'
import type { FC, ReactNode } from 'react'
import type { Case } from '@/prakrit/lib/grammar/types'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { PremiumGate } from '@/components/plans/plan-notice'
import { VibhaktiCases } from '@/prakrit/components/grammar/shabd/vibhakti-cases'
import { isCase } from '@/prakrit/components/grammar/shabd/case-info'

interface VibhaktiPageProps {
    caseName: Case
}

const VibhaktiPage: FC<VibhaktiPageProps> = ({ caseName }): ReactNode => (
    <Layout>
        <Seo
            title='Noun cases'
            description='विभक्तयः: the eight Prakrit cases one at a time, each with its role, Hindi marker, the question it answers and a model sentence with audio.'
        />
        <PremiumGate kind='grammar'>
            <VibhaktiCases initialCase={caseName} />
        </PremiumGate>
    </Layout>
)

const first = (value: string | string[] | undefined): string => (Array.isArray(value) ? value[0] ?? '' : value ?? '')

export const getServerSideProps: GetServerSideProps<VibhaktiPageProps> = async ({ query }) => {
    // Old links to the declension table (/grammar/vibhakti?stem=…) go on to the declension laboratory.
    if (first(query.stem)) {
        const params = new URLSearchParams()

        for (const [key, value] of Object.entries(query)) {
            for (const v of Array.isArray(value) ? value : value === undefined ? [] : [value]) params.append(key, v)
        }

        return { redirect: { destination: `/grammar/shabdarup?${params.toString()}`, permanent: false } }
    }

    const c = first(query.case)

    return { props: { caseName: isCase(c) ? c : 'prathama' } }
}

export default VibhaktiPage
